module.exports = __webpack_public_path__ + "static/autohide-0ec0296dd8989d7ac1c9f202c566a16d.mp4";